"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugify = slugify;
exports.unslugify = unslugify;
/**
 * Converts a string into a URL-friendly slug based on the specified language.
 * The slug is normalized to lowercase, accents are removed, and special characters are replaced or trimmed.
 *
 * To revert the transformation, use the `unslugify` function.
 *
 * @param {string} name - The input string to be slugified.
 * @param {Languages} language - The language used for locale-specific transformations.
 * @returns {string} - The slugified version of the input string.
 */
function slugify(name, language) {
  try {
    var _name$toLocaleLowerCa;
    return name === null || name === void 0 || (_name$toLocaleLowerCa = name.toLocaleLowerCase(language) // Convert to lowercase respecting locale
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.normalize('NFD') // Normalize accents
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.replace(/[\u0300-\u036f]/g, '') // Remove accent marks
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.replace(/&/g, 'and') // Replace '&' with 'and'
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.replace(/\s+/g, '-') // Replace spaces with '-'
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.replace(/[^a-z0-9-]/g, '') // Remove invalid characters
    ) === null || _name$toLocaleLowerCa === void 0 || (_name$toLocaleLowerCa = _name$toLocaleLowerCa.replace(/-+/g, '-') // Remove duplicate '-'
    ) === null || _name$toLocaleLowerCa === void 0 ? void 0 : _name$toLocaleLowerCa.replace(/^-|-$/g, ''); // Trim leading and trailing '-'
  } catch (_unused) {
    return name;
  }
}

/**
 * Converts a slugified string back into a more human-readable format.
 * Replaces dashes with spaces and capitalizes each word.
 *
 * Note: This does not restore removed accents or special characters.
 * To apply the reverse operation, use the `slugify` function.
 *
 * @param {string} slug - The slugified string.
 * @returns {string} - A more readable version of the input slug.
 */
function unslugify(slug) {
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}